import { createTheme } from "@mui/material/styles";

export const bodyFontFamily = [
  "Inter",
  "Roboto",
  "system-ui",
  "sans-serif",
].join(",");
export const displayFontFamily = ["Cinzel", "Georgia", "serif"].join(",");

const manaColors = {
  white: "#F8F6D8",
  blue: "#0E68AB",
  black: "#150B00",
  red: "#D3202A",
  green: "#00733E",
  colorless: "#C6C6C6",
};

declare module "@mui/material/styles" {
  interface Theme {
    mana: typeof manaColors;
  }
  interface ThemeOptions {
    mana?: typeof manaColors;
  }
}

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#121212",
      paper: "#1B1B1B",
    },
    primary: {
      main: "#0E68AB",
    },
    secondary: {
      main: "#D3202A",
    },
    text: {
      primary: "#EAEAEA",
      secondary: "#9CA3AF",
    },
  },

  mana: manaColors,

  shape: {
    borderRadius: 10,
  },

  typography: {
    fontFamily: bodyFontFamily,
    h1: { fontFamily: displayFontFamily, fontWeight: 700 },
    h2: { fontFamily: displayFontFamily, fontWeight: 700 },
    h3: { fontFamily: displayFontFamily, fontWeight: 700 },
    h4: { fontFamily: displayFontFamily, fontWeight: 700 },
    h5: { fontFamily: displayFontFamily, fontWeight: 700 },
    h6: { fontFamily: displayFontFamily, fontWeight: 700 },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#121212",
          backgroundImage:
            "radial-gradient(circle at top, rgba(255,255,255,0.03), transparent 35%)",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          background: "#1B1B1B",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.6)",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },

    MuiButton: {
      defaultProps: {
        variant: "contained",
      },
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
          borderRadius: 10,
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },
  },
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#F4F1E8",
      paper: "#FFFFFF",
    },
    primary: {
      main: "#0E68AB",
    },
    secondary: {
      main: "#D3202A",
    },
    text: {
      primary: "#1B1B1B",
      secondary: "#4B5563",
    },
  },

  mana: manaColors,

  shape: {
    borderRadius: 10,
  },

  typography: {
    fontFamily: bodyFontFamily,
    h1: { fontFamily: displayFontFamily, fontWeight: 700 },
    h2: { fontFamily: displayFontFamily, fontWeight: 700 },
    h3: { fontFamily: displayFontFamily, fontWeight: 700 },
    h4: { fontFamily: displayFontFamily, fontWeight: 700 },
    h5: { fontFamily: displayFontFamily, fontWeight: 700 },
    h6: { fontFamily: displayFontFamily, fontWeight: 700 },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F4F1E8",
          backgroundImage:
            "radial-gradient(circle at top, rgba(0,0,0,0.03), transparent 35%)",
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          background: "#FFFFFF",
          border: "1px solid rgba(0,0,0,0.08)",
          boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },

    MuiButton: {
      defaultProps: {
        variant: "contained",
      },
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
          borderRadius: 10,
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
          borderRadius: 999,
          fontWeight: 600,
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: bodyFontFamily,
        },
      },
    },
  },
});
